<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="nav-bar">
	<div class="tp-top-header not-fixed tp-top-header-zindex">
		<!-- This is the TouchPlan logo. It is always visible unless we're on the plan page -->
		<div *ngIf="!hideLogo" class="tp-top-header-logo" (click)="goToProjects()">
			<img
				class="clickable nav-bar-full-logo"
				src="assets/images/touchplan-dashboard-logo.png"
				alt="Touchplan"
				width="auto"
				height="34"
			/>
		</div>

		<!-- Intentionally avoid adding styling here -->
		<div>
			<ng-content></ng-content>
		</div>
	</div>
</div>
